import { colors } from '@/theme/colors';

export type ChooseYourCarIconProps = {
  size?: { width: number; height: number };
  fillColorCar?: string;
  fillColorLaptop?: string;
};

export default function ChooseYourCarIcon({
  size = { width: 64, height: 44 },
  fillColorCar = colors.aqua40,
  fillColorLaptop = colors.blue20,
}: ChooseYourCarIconProps) {
  return (
    <svg
      width={`${size.width}px`}
      height={`${size.height}px`}
      viewBox={`0 0 ${size.width} ${size.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_435_11174)">
        <path
          d="M51.4136 30.581H50.2887C48.7971 30.581 47.5836 29.3865 47.5836 27.9183V27.497H32.0253V27.9183C32.0253 29.3865 30.8118 30.581 29.3202 30.581H28.1953C26.7037 30.581 25.4902 29.3865 25.4902 27.9183V19.5479C25.4902 19.3012 25.3526 19.0695 25.1356 18.9462L24.5579 18.6212C24.13 18.4377 23.8457 18.0165 23.8457 17.5531V15.9344C23.8457 15.2905 24.3776 14.767 25.0317 14.767H26.6242C27.0338 14.767 27.4097 14.5474 27.6054 14.1923L29.9284 10.0011C30.5061 8.96012 31.6126 8.31323 32.817 8.31323H46.7919C47.9962 8.31323 49.1027 8.96012 49.6805 10.0011L52.0035 14.1923C52.1991 14.5474 52.5751 14.767 52.9847 14.767H54.5772C55.2313 14.767 55.7632 15.2905 55.7632 15.9344V17.5531C55.7632 18.0165 55.4789 18.4377 55.051 18.6212L54.4733 18.9462C54.2532 19.0695 54.1187 19.2982 54.1187 19.5479V27.9183C54.1187 29.3865 52.9052 30.581 51.4136 30.581ZM31.3314 26.1281H48.2805C48.6656 26.1281 48.9774 26.435 48.9774 26.8141V27.9213C48.9774 28.6343 49.5674 29.215 50.2918 29.215H51.4166C52.1411 29.215 52.731 28.6343 52.731 27.9213V19.5509C52.731 18.8108 53.1375 18.1248 53.7886 17.7607L54.3755 17.4328V16.142H52.9908C52.0707 16.142 51.2271 15.6486 50.787 14.8543L48.4639 10.6631C48.1307 10.0613 47.4919 9.68823 46.798 9.68823H32.8231C32.1292 9.68823 31.4904 10.0613 31.1572 10.6631L28.8341 14.8543C28.394 15.6486 27.5504 16.142 26.6303 16.142H25.2456V17.4328L25.8325 17.7607C26.4836 18.1248 26.8901 18.8108 26.8901 19.5509V27.9213C26.8901 28.6343 27.4801 29.215 28.2045 29.215H29.3293C30.0537 29.215 30.6437 28.6343 30.6437 27.9213V26.8141C30.6437 26.435 30.9555 26.1281 31.3406 26.1281H31.3314Z"
          fill={fillColorCar}
        />
        <path
          d="M31.3311 27.497H29.2282C28.843 27.497 28.5312 27.1901 28.5312 26.811C28.5312 26.4319 28.843 26.125 29.2282 26.125H31.3311C31.7163 26.125 32.0281 26.4319 32.0281 26.811C32.0281 27.1901 31.7163 27.497 31.3311 27.497Z"
          fill={fillColorCar}
        />
        <path
          d="M50.3819 27.497H48.2789C47.8938 27.497 47.582 27.1901 47.582 26.811C47.582 26.4319 47.8938 26.125 48.2789 26.125H50.3819C50.7671 26.125 51.0788 26.4319 51.0788 26.811C51.0788 27.1901 50.7671 27.497 50.3819 27.497Z"
          fill={fillColorCar}
        />
        <path
          d="M18.2455 22.4452H9.90395C9.51881 22.4452 9.20703 22.1383 9.20703 21.7592C9.20703 21.3801 9.51881 21.0732 9.90395 21.0732H18.2455C18.6307 21.0732 18.9424 21.3801 18.9424 21.7592C18.9424 22.1383 18.6307 22.4452 18.2455 22.4452Z"
          fill={fillColorLaptop}
        />
        <path
          d="M18.2455 25.5954H9.90395C9.51881 25.5954 9.20703 25.2885 9.20703 24.9094C9.20703 24.5303 9.51881 24.2234 9.90395 24.2234H18.2455C18.6307 24.2234 18.9424 24.5303 18.9424 24.9094C18.9424 25.2885 18.6307 25.5954 18.2455 25.5954Z"
          fill={fillColorLaptop}
        />
        <path
          d="M18.2455 28.7426H9.90395C9.51881 28.7426 9.20703 28.4357 9.20703 28.0566C9.20703 27.6775 9.51881 27.3706 9.90395 27.3706H18.2455C18.6307 27.3706 18.9424 27.6775 18.9424 28.0566C18.9424 28.4357 18.6307 28.7426 18.2455 28.7426Z"
          fill={fillColorLaptop}
        />
        <path
          d="M61.1787 44.0001H2.82128C1.26545 44.0001 0 42.7545 0 41.223V38.133C0 37.7539 0.311778 37.447 0.696915 37.447H63.3031C63.6882 37.447 64 37.7539 64 38.133V41.223C64 42.7545 62.7345 44.0001 61.1787 44.0001ZM1.39077 38.816V41.223C1.39077 41.9993 2.03267 42.6311 2.82128 42.6311H61.1787C61.9673 42.6311 62.6092 41.9993 62.6092 41.223V38.816H1.39077Z"
          fill={fillColorLaptop}
        />
        <path
          d="M59.2261 38.8159H4.77504C4.3899 38.8159 4.07812 38.509 4.07812 38.1299V2.65673C4.07812 1.19147 5.29161 0 6.77714 0H57.224C58.7126 0 59.923 1.19147 59.923 2.65673V38.1329C59.923 38.512 59.6112 38.8189 59.2261 38.8189V38.8159ZM5.47195 37.4469H58.5292V2.65673C58.5292 1.94666 57.9423 1.36898 57.2209 1.36898H6.77714C6.05577 1.36898 5.4689 1.94666 5.4689 2.65673V37.4469H5.47195Z"
          fill={fillColorLaptop}
        />
        <path
          d="M18.4619 18.3263H9.68324C9.29811 18.3263 8.98633 18.0194 8.98633 17.6403V9.00216C8.98633 8.62306 9.29811 8.31616 9.68324 8.31616H18.4619C18.8471 8.31616 19.1588 8.62306 19.1588 9.00216V17.6433C19.1588 18.0224 18.8471 18.3293 18.4619 18.3293V18.3263ZM10.3802 16.9573H17.7681V9.68514H10.3802V16.9573Z"
          fill={fillColorLaptop}
        />
      </g>
    </svg>
  );
}
